import { useNavigate } from 'react-router-dom'

import { EmployeeBulkAddTimeoffModalPageDocument } from 'generated/resources/graphql'

import { SkeletonModal } from 'modules/core/components/Modal'
import { useAsyncData } from 'modules/core/hooks/useAsyncData'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import { useQuery } from 'modules/core/hooks/useQuery'

import BulkAddLeavesModal from 'modules/timeoff/components/BulkAddLeavesModal'
import timeoffAllowances from 'modules/timeoff/store/collections/allowances'

const BulkAddTimeoffModalPage = () => {
  const navigate = useNavigate()
  const { navigation } = useNavigation()
  const { loading, data } = useQuery(EmployeeBulkAddTimeoffModalPageDocument)

  // NOTE: this needs to be migrated to the GraphQL page query
  const { loading: isLoadingTimeoffAllowances } = useAsyncData(
    () => timeoffAllowances.fetch({ withCachedFetchParams: true }),
    []
  )

  if (loading || isLoadingTimeoffAllowances) {
    return <SkeletonModal />
  }

  if (!data?.apiCore.currentsConnection.edges[0]?.node.employee) {
    throw new Error('Current employee not found')
  }

  const currentEmployee = data.apiCore.currentsConnection.edges[0].node.employee

  return (
    <BulkAddLeavesModal
      onClose={() => navigate(navigation.employees.list.fullPath())}
      currentEmployee={currentEmployee}
    />
  )
}

export default BulkAddTimeoffModalPage
